var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.945 3.374 6 5.32 4.054 3.375a.48.48 0 0 0-.68 0l-.033.036a.482.482 0 0 0 .033.644L5.32 6 3.375 7.946a.48.48 0 0 0 .34.82l.047-.002a.474.474 0 0 0 .293-.138L6 6.68l1.946 1.945a.48.48 0 0 0 .82-.34l-.002-.047a.469.469 0 0 0-.138-.292L6.68 6l1.946-1.946a.48.48 0 1 0-.68-.68z"
  }))));
};
export default SvgDelete;